export class FinalBeneficiaries {
    Id: number;
    IdRequest: number;
    BeneficiaryType: string;
    Names: string;
    LastNames: string;
    BusinessName: string;
    TaxIdNumber: string;
    DocumentNumber: string;
    IdNationality: string;
    NationalityName: string;
    BirthDate: Date;
    create_By: string;
    create_Date: Date;
    modified_By: string;
    modified_Date: Date;
}